import { SelectOption } from 'components/form-inputs/select-option/select-option';

export enum TimeOfDay {
  Morning = 'morning',
  Evening = 'evening',
}

export type TimeOfDaySelectOption = SelectOption<TimeOfDay, string>;
